import { DimensionType } from '../../types';

/**
 * Maps each child dimension to its required parent dimensions.
 * Ensures groupBy keys include the context needed for uniqueness
 * (e.g., environment → project, SDK version → SDK name).
 */
export const CHILD_TO_PARENT_DIMENSIONS: Partial<Record<DimensionType, readonly DimensionType[]>> = {
  [DimensionType.ENVIRONMENT_ID]: [DimensionType.PROJECT_ID],
  [DimensionType.SDK_VERSION]: [DimensionType.SDK_NAME],
} as const;

export const V1_SDK_METADATA_KEYS = { sdk: 'sdk', version: 'version', type: 'type' } as const;

export const serviceConnectionsDimensions = [
  DimensionType.PROJECT_ID,
  DimensionType.ENVIRONMENT_ID,
  DimensionType.CONNECTION_TYPE,
  DimensionType.RELAY_VERSION,
  DimensionType.SDK_NAME,
  DimensionType.SDK_VERSION,
  DimensionType.SDK_TYPE,
  DimensionType.SDK_APP_ID,
];
export const clientSideMAUDimensions = [
  DimensionType.PROJECT_ID,
  DimensionType.ENVIRONMENT_ID,
  DimensionType.SDK_NAME,
  DimensionType.SDK_APP_ID,
  DimensionType.ANONYMOUS_V2,
];
export const experimentationKeysDimensions = [DimensionType.PROJECT_ID, DimensionType.ENVIRONMENT_ID];

// Excludes environment ID because project ID isn't available in the experimentation events API.
export const experimentationEventsDimensions = [DimensionType.EVENT_KIND, DimensionType.EVENT_KEY];
export const experimentationMAUDimensions = [
  DimensionType.PROJECT_ID,
  DimensionType.ENVIRONMENT_ID,
  DimensionType.SDK_NAME,
  DimensionType.SDK_TYPE,
  DimensionType.SDK_APP_ID,
  DimensionType.ANONYMOUS_V2,
];

// Excludes environment ID because project ID isn't available in the data export API.
export const dataExportDimensions = [DimensionType.EVENT_KIND];

export const dataExportCombinedDimensions = [
  DimensionType.ENVIRONMENT_ID,
  DimensionType.EVENT_KIND,
  DimensionType.DESTINATION_ID,
  DimensionType.DESTINATION_KIND,
];

export const warehouseExportDimensions = [
  DimensionType.PROJECT_ID,
  DimensionType.ENVIRONMENT_ID,
  DimensionType.DESTINATION,
];

export const observabilityDimensions = [DimensionType.PROJECT_ID];

export const contextsDimensions = [
  DimensionType.CONTEXT_KIND,
  DimensionType.PROJECT_ID,
  DimensionType.ENVIRONMENT_ID,
  DimensionType.SDK_NAME,
  DimensionType.SDK_APP_ID,
  DimensionType.ANONYMOUS_V2,
];

export const peakConcurrentConnectionsDimensions = [DimensionType.SDK_VERSION_V1];

export const aiRunsDimensions = [
  DimensionType.PROJECT_ID,
  DimensionType.ENVIRONMENT_ID,
  DimensionType.SDK_NAME,
  DimensionType.SDK_VERSION,
  DimensionType.SDK_TYPE,
  DimensionType.SDK_APP_ID,
];
